// src/context/AuthContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const history = useHistory();

    useEffect(() => {
        // Check if user is logged in (this could be an API call)
        const loggedInUser = JSON.parse(localStorage.getItem("user"));
        console.log("Logged in user:", loggedInUser);
        if (history.location.pathname.includes('/registerpage2/') 
            || history.location.pathname.includes('/changepassword/') 
        || history.location.pathname.includes('/login') 
        || history.location.pathname.includes('/forgotpassword')
        || history.location.pathname.includes('/contactus')
        ) {
            setUser(null);
        } else if (loggedInUser) {
            setUser(loggedInUser);
        } else {
            history.push("/login");
        }
    }, [history]);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
